import data from "./site.json";

export const LAUNCH_CONFIRM = "CONFIRM BEFORE LAUNCH" as const;

export type NavItem = { label: string; href: string };

export const site = data.site;
export const brand = data.brand;
export const navigation = data.navigation as {
  services: NavItem[];
  industries: NavItem[];
  main: NavItem[];
};
export const pages = data.pages;
export const services = data.services;
export const industries = data.industries;
export const testimonials = data.testimonials;
export const process = data.process;
export const packages = data.packages;
export const reviewForm = data.reviewForm;
export const assessment = data.assessment;

export function pageMeta(route: string) {
  return pages.find((p) => p.route === route);
}

export function isConfirmed(value: string | undefined | null): boolean {
  return !!value && value !== LAUNCH_CONFIRM;
}
